import * as React from 'react';

import { ModalContainer } from './styles';
import { createPortal } from 'react-dom';

interface ModalProps {
    shouldShow: boolean
}

class Modal extends React.Component<ModalProps,{}> {
    constructor(props: ModalProps) {
        super(props);
        this.renderModalContent = this.renderModalContent.bind(this);
    }

    public renderModalContent() {
        return(
            <ModalContainer shouldShow={this.props.shouldShow}>
                {
                    this.props.children
                }
            </ModalContainer>
        )
    }

    public render() {
        return this.renderModalContent()
    }
}

export default Modal;
